// extracted by mini-css-extract-plugin
export default {"overlay":"MusicVideo_overlay__jJ1ct","player":"MusicVideo_player__zQ4RI"};